import script from "./LCFormDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./LCFormDialog.vue?vue&type=script&setup=true&lang=js"

import "./LCFormDialog.vue?vue&type=style&index=0&id=3be8ba12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3be8ba12"]])

export default __exports__